module.exports = __webpack_public_path__ + "static/media/man in suit_rome.815a6174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/man in suit_rome.jpg
// module id = 458
// module chunks = 0